'use client';

import { useEffect, useState } from 'react';

import BrandLogo from './BrandLogo';
import DesktopNavigation from './DesktopNavigation';
import { MobileNavigation, NavSection } from './MobileNavigation';
import ToolsNavigation from './ToolsNavigation';

const DEFAULT_DRAWER_SECTIONS: NavSection[] = [
  {
    items: [
      { id: 1, href: '/', label: 'Inicio' },
      { id: 2, href: '/new-arrivals', label: 'New In' },
    ],
  },
  {
    label: 'Categorías',
    items: [
      {
        id: 1,
        href: '/search?page=1&min_price=1&line=baby+shower',
        label: 'Baby Shower (0 a 3 meses)',
      },
      {
        id: 2,
        label: 'Bebés',
        children: [
          { id: 1, href: '/search?page=1&min_price=1&line=bebe+varon', label: 'Varón (3 a 24 meses)' },
          { id: 2, href: '/search?page=1&min_price=1&line=bebe+nena', label: 'Nena (3 a 24 meses)' },
        ],
      },
      {
        id: 3,
        label: 'Minis',
        children: [
          { id: 1, href: '/search?page=1&min_price=1&line=minis+varon', label: 'Varón (2 a 8 años)' },
          { id: 2, href: '/search?page=1&min_price=1&line=minis+nena', label: 'Nena (2 a 8 años)' },
        ],
      },
      {
        id: 4,
        href: '/search?page=1&min_price=1&line=junior+varon',
        label: 'Junior Varón (8 a 16 años)',
      },
      {
        id: 5,
        href: '/search?page=1&min_price=1&line=felicia',
        label: 'Felicia (8 a 16 años)',
      },
    ],
  },
  {
    className: 'mt-1 gap-5',
    items: [
      {
        id: 1,
        href: '/deals',
        label: 'Outlet',
        icon: 'fire',
        className: 'font-bold text-error-500 hover:text-error-200',
      },
      {
        id: 2,
        href: 'https://www.crayonropadechicos.com.ar/seccionClientes/Login',
        label: 'Mayoristas',
        icon: 'store',
        className: 'font-bold',
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    ],
  },
];

export type HeaderProps = {
  mocked?: boolean;
  logoSrc?: string;
  isHome?: boolean;
  desktopNavItems?: Array<{
    label: string;
    href: string;
    icon?: string;
    className?: string;
    target?: string;
    rel?: string;
  }>;
};

const Header = ({ desktopNavItems = [], logoSrc = '/logo-crayon-bak.png', mocked = false, isHome = false }: HeaderProps) => {
  const [headerData, setHeaderData] = useState<Omit<HeaderProps, 'mocked'>>();
  useEffect(() => {
    if (mocked) {
      setHeaderData({
        logoSrc,
        desktopNavItems: [
          { label: 'New In', href: '#' },
          { label: 'Outlet', href: '#', icon: 'fire', className: 'text-error font-bold' },
          { label: 'Mayoristas', href: '#' },
        ],
      });
    } else {
      // Fetch real header data from an API or context
      // For now, we will just use the mocked data
      setHeaderData({
        logoSrc,
        desktopNavItems,
      });
    }
  }, [mocked]);

  if (!headerData) return null;

  return (
    <header
      className={`flex flex-row items-center shadow-xs fixed top-0 left-0 right-0 z-50
                            ${isHome ? 'bg-white/40' : 'bg-white'}`}
    >
      <div className="w-25">
        <MobileNavigation sections={DEFAULT_DRAWER_SECTIONS} />
      </div>
      <div className="">
        <BrandLogo src={headerData.logoSrc || '/logo-crayon-bak.png'} />
      </div>
      <div className="flex-1 flex flex-row justify-center">
        <DesktopNavigation items={headerData.desktopNavItems} />
      </div>
      <div className="">
        <ToolsNavigation />
      </div>
    </header>
  );
};

export default Header;
